import React from "react";
import TokenCube from "./TokenCube";
import { X_START, Y_START, X_STEP, Y_STEP } from "./court.data";

const CourtTokens = ({ tokens = [] }) => {
  return(
    <>
      {tokens?.map((token, key) => {
        // Translate xAxis/yAxis indices to actual screen pixels
        const screenX = X_START + (parseFloat(token?.xAxis) * X_STEP);
        const screenY = Y_START + (parseFloat(token?.yAxis) * Y_STEP);

        return (
          <TokenCube
            key={key}
            position={{ ...token, x: screenX, y: screenY }}
          />
        );
      })}
    </>
  )
};

export default React.memo(CourtTokens);
